<template>
    <div class="virtual-dom" ref="domRef"> 
        <p>
            <el-button  
                type="primary" size="mini" plain 
                @click="()=>$emit('add-condition')"
                :loading="!!loadingData.conditionLoading"
            >
                {{addType}}筛选
            </el-button>
            <el-button  type="primary" size="mini" plain @click="()=>$emit('copy-content')">复制内容</el-button>
        </p>
        <p class="mt6">
            <el-button  
                type="primary" size="mini" plain
                @click="()=>$emit('add-condition', true)"
                :loading="!!loadingData.conditionLoading"
            >
                {{addType}}筛选并作为第一维度
            </el-button>
        </p>
    </div>
</template>

<script>
import { on, off } from 'element-ui/src/utils/dom';
export default {
    props: [ 'field' ],
    inject: [ 'loadingData', 'global' ],
    methods: {
        handleEnter() {
            this.$emit('enter')
        },
        handleLeave() {
            this.$emit('leave')
        },
    },
    computed: {
        addType() {
            const names = this.global.conditionCheckList.map(v=>v.name)
            return names.includes(this.field) ? '追加': '添加'
        }
    },
    mounted() {
        this.$nextTick(()=> {
            const domRef = this.$refs.domRef;
            on(domRef, 'mouseenter', this.handleEnter);
            on(domRef, 'mouseleave', this.handleLeave);
        })
    },
    destroyed() {
        const domRef = this.$refs.domRef;
        off(domRef, 'mouseenter', this.handleEnter);
        off(domRef, 'mouseleave', this.handleLeave);
    }
}
</script>

<style lang="scss" scoped>
.virtual-dom{
    width: 220px;
    height: 80px;
    background: #fff;
    position: fixed;
    top: var(--y);
    left: var(--x);
    z-index: 999999;
    border: solid 1px #dedede;
    box-shadow: 3px 3px 5px 1px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    padding: 10px;
}
</style>